import styled from '@emotion/styled';

import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';
import { BreakPointToken } from '../../hooks/useMediaQuery';

const {
	spacing: {
		size_8px: { height: size_8 },
		size_16px: { height: size_16 }
	}
} = tokens;

export const HolidayInfoList = styled.ul`
	@media (min-width: ${BreakPointToken.MdMin}px) {
		display: flex;
	}
	list-style: none;
	margin: ${size_16}px 0 0 0;
	padding: 0;
`;

export const HolidayInfoListItem = styled.li`
	display: flex;
	align-items: center;
	margin-top: ${size_8}px;
	@media (min-width: ${BreakPointToken.MdMin}px) {
		margin-top: 0;
		margin-inline-end: ${size_16}px;
	}

	svg {
		margin-inline-end: ${size_8}px;
	}
`;
